import './UniModalHolidayConfiguration.scss';
import { faCircleCheck, faUserAlt, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { Factories, HolidayConfigurationDto, HolidayCountry, HolidayType, upsert } from "../../services/holidaysConfigurationService";
import UniModal from "../UniModal/UniModal";
import { useTranslation } from 'react-i18next';
import UniInput from '../UniInput/UniInput';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';

const UniModalHolidayConfiguration = (props: any) => {
    const [isNew, setIsNew] = useState(false);
    const [selectedItem, setSelectedItem] = useState<HolidayConfigurationDto>(props.item);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [errorType, setErrorType] = useState(false);
    const [errorCountry, setErrorCountry] = useState(false);
    const [errorYear, setErrorYear] = useState(false);
    const [errorFactory, setErrorFactory] = useState(false);
    const [errorDescription, setErrorDescription] = useState(false);
    const [errorDates, setErrorDates] = useState(false);
    const [loading, setLoading] = useState(false);    
    const { t, i18n } = useTranslation();

    const holidayTypes = [
        { value: HolidayType.Office, label: t(HolidayType[HolidayType.Office].toLowerCase()) },
        { value: HolidayType.Factory, label: t(HolidayType[HolidayType.Factory].toLowerCase()) },
    ]

    const holidayCountries = [
        { value: HolidayCountry.AR, label: HolidayCountry.AR },
        { value: HolidayCountry.BR, label: HolidayCountry.BR },
    ]

    const currentYear = new Date().getFullYear();
    const years = [
        {value: currentYear.toString(), label: currentYear.toString()}, 
        {value: (currentYear + 1).toString(), label: (currentYear + 1).toString()}, 
        {value: (currentYear + 2).toString(), label: (currentYear + 2).toString()}
    ];

    const [factories, setFactories] = useState([
        { value: Factories.BHI_BCA, label: Factories.BHI_BCA }
    ]);

    const [selectedDates, setSelectedDates] = useState<Date[]>();
    
    useEffect(() => {
        if (props.show) {
            if(props.item?.id && props.item?.id !== '') {
                setIsNew(false);
                setSelectedItem({...props.item});
                let values = [];
                for (let index = 0; index < props.item?.value?.length; index++) {
                    const element = props.item?.value[index];
                    values.push(moment(props?.item?.year + '-' + element.split('/')[1] + '-' + element.split('/')[0]).toDate());
                }
                setSelectedDates(values);
            } else {
                setIsNew(true);
                setSelectedItem({
                    id: undefined,
                    type: undefined,
                    country: undefined,
                    description: '',
                    year: undefined,
                    value: [],
                    factory: undefined
                } as any as HolidayConfigurationDto);
                setSelectedDates([]);
            }
        }
    }, [props.show]);

    useEffect(() => {
        if(selectedItem?.type === t(HolidayType[HolidayType.Factory].toLowerCase())) {
            if(selectedItem.country === HolidayCountry.AR) {
                setFactories([
                    { value: Factories.BHI_BCA, label: Factories.BHI_BCA }
                ]);
            } else {
                setFactories([
                    { value: Factories.CUBATAO, label: Factories.CUBATAO },
                    { value: Factories.SANTO_ANDRE, label: Factories.SANTO_ANDRE },
                ]);
            }
        } else {
            setSelectedItem({...selectedItem, factory: undefined} as any as HolidayConfigurationDto);
        }
    }, [selectedItem?.type, selectedItem?.country]);

    useEffect(() => {
        if(!factories?.find(x => x.label === selectedItem?.factory)) {
            setSelectedItem({...selectedItem, factory: undefined} as any as HolidayConfigurationDto);
        }
    }, [factories]);

    useEffect(() => {
        if(selectedDates && selectedDates.length > 0 && selectedDates[0].getFullYear().toString() !== selectedItem?.year) {
            setSelectedDates([]);
            setSelectedItem({...selectedItem, value: []});
        }
    }, [selectedItem?.year]);

    const onChangeSelectedDates = (dates: Date[]) => {
        setSelectedDates(dates);        
        const values = dates?.sort((a,b)=>a.getTime()-b.getTime()).map(x => {
            return (x.getDate() < 10 ? '0' + (x.getDate()) : x.getDate()) + '/' + (x.getMonth() + 1 < 10 ? '0' + (x.getMonth() + 1) : x.getMonth() + 1);
        });
        setSelectedItem({...selectedItem, value: values ?? []});
    };

    const hide = () => {
        setErrorMessage('');
        setErrorType(false);
        setErrorCountry(false);
        setErrorYear(false);
        setErrorFactory(false);
        setErrorDescription(false);
        setErrorDates(false);
    
        props.onHide();
    }

    const isItemValid = (): Boolean => {
        let isValid = true;
        if (!selectedItem.type || selectedItem.type === '') {
            setErrorType(true);
            isValid = false;
        } else {
            setErrorType(false);
        }
        if (!selectedItem.country) {
            setErrorCountry(true);
            isValid = false;
        } else {
            setErrorCountry(false);
        }
        if (!selectedItem.year || selectedItem.year === '') {
            setErrorYear(true);
            isValid = false;
        } else {
            setErrorYear(false);
        }
        if (selectedItem.type === t(HolidayType[HolidayType.Factory].toLowerCase()) && (!selectedItem.factory || selectedItem.factory === '')) {
            setErrorFactory(true);
            isValid = false;
        } else {
            setErrorFactory(false);
        }
        if (!selectedItem.description || selectedItem.description === '') {
            setErrorDescription(true);
            isValid = false;
        } else {
            setErrorDescription(false);
        }
        if (!selectedDates || selectedDates.length === 0) {
            setErrorDates(true);
            isValid = false;
        } else {
            setErrorDates(false);
        }

        return isValid;
    }

    const updateItem = async (event: any) => {
        event.preventDefault();
        event.stopPropagation();

        if(!isItemValid()) {
            return
        }

        setLoading(true);
        const response = await upsert(selectedItem);
        setLoading(false);

        if (!!response.success) {
            setShowModalSuccess(true);
            props.onHide();
        }
        else {
            setErrorMessage(response.error ? response.error : t('errorSave'));
            setShowModalError(true);
        }
    }

    return (
        <>
            <Modal
                show={props.show}
                onHide={() => hide()}
                className={'modal-holiday-configuration'}
            >
                <Modal.Header closeButton>
                    <div className='header-body'>
                        <Modal.Title className='mt-3'>
                            {isNew ? t('new') : t('edit')}
                        </Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {                        
                        <Form onSubmit={updateItem} className='form-edit'>
                            <div className='d-flex justify-content-between w-100'>
                                <div className='type-inputs'>
                                    <label className='label'>{t('type')}</label>
                                    <div>
                                        {loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                            <Select
                                                key={`holiday_types_${selectedItem?.type}`}
                                                isDisabled={!isNew}
                                                placeholder={t('select')}
                                                value={holidayTypes.find(x=> x.label === selectedItem?.type)}
                                                onChange={(value) => {
                                                    setSelectedItem({
                                                        ...selectedItem, 
                                                        type: value?.label ?? ''
                                                    });
                                                }}
                                                options={holidayTypes}
                                                className='select-type'
                                            />
                                        )}
                                    </div>
                                    {errorType && (<p className='p-error'>{t('validateType')}</p>)}
                                </div>
                                <div className='type-inputs'>
                                    <label className='label'>{t('country')}</label>
                                    <div>
                                        {loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                            <Select
                                                key={`countries_${selectedItem?.country}`}
                                                isDisabled={!isNew}
                                                placeholder={t('select')}
                                                value={holidayCountries.find(x=> x.value === selectedItem?.country)}
                                                onChange={(value) => {
                                                    setSelectedItem({
                                                        ...selectedItem, 
                                                        country: value?.value ?? HolidayCountry.AR
                                                    });
                                                }}
                                                options={holidayCountries}
                                                className='select-type'
                                            />
                                        )}
                                    </div>
                                    {errorCountry && (<p className='p-error'>{t('validateCountry')}</p>)}
                                </div>
                            </div>

                            <div className='d-flex justify-content-between w-100'>
                                <div className='type-inputs'>
                                    <label className='label'>{t('year')}</label>
                                    <div>
                                        {loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                            <Select
                                                key={`years_${selectedItem?.year}`}
                                                isDisabled={!isNew}
                                                placeholder={t('select')}
                                                value={years.find(x=> x.value === selectedItem?.year)}
                                                onChange={(value) => {
                                                    setSelectedItem({
                                                        ...selectedItem, 
                                                        year: value?.value ?? new Date().getFullYear() + ''
                                                    });
                                                }}
                                                options={years}
                                                className='select-type'
                                            />
                                        )}
                                    </div>                                    
                                    {errorYear && (<p className='p-error'>{t('validateYear')}</p>)}
                                </div>
                                {selectedItem?.type === t(HolidayType[HolidayType.Factory].toLowerCase()) && (
                                    <div className='type-inputs'>
                                        <label className='label'>{t('factory')}</label>
                                        <div>
                                            {loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                                <Select
                                                    key={`factories_${selectedItem?.factory}`}
                                                    isDisabled={!isNew}                                                
                                                    placeholder={t('select')}
                                                    value={factories.find(x=> x.label === selectedItem?.factory)}
                                                    onChange={(value) => {
                                                        setSelectedItem({
                                                            ...selectedItem, 
                                                            factory: value?.value ?? Factories.CUBATAO
                                                        });
                                                    }}
                                                    options={factories}
                                                    className='select-type'
                                                />
                                            )}
                                        </div>
                                        {errorFactory && (<p className='p-error'>{t('validateFactory')}</p>)}
                                    </div>
                                )}
                            </div>

                            <div className='description'>                                
                                <UniInput
                                    id='description'
                                    disabled={!isNew}
                                    label={t('description')}
                                    type='text'
                                    value={selectedItem?.description}                                    
                                    onChangeInput={(value) => {
                                        setSelectedItem({
                                            ...selectedItem, 
                                            description: value?.target?.value
                                        });
                                    }}
                                    props={{size: 'sm'}}
                                />
                                {errorDescription && (<p className='p-error'>{t('validateDescription')}</p>)}
                            </div>
                            
                            {selectedItem?.year && (
                                <>
                                    <ReactDatePicker
                                        key={`dates_${selectedItem?.year}`}
                                        selectedDates={selectedDates}
                                        onChange={onChangeSelectedDates}
                                        selectsMultiple
                                        monthsShown={2}
                                        openToDate={(selectedDates?.length ?? 0 ) > 0 ? (selectedDates && selectedDates[0]) : moment(selectedItem?.year + '-01-01').toDate()}
                                        minDate={moment(selectedItem?.year + '-01-01').toDate()}
                                        maxDate={moment(selectedItem?.year + '-12-31').toDate()}
                                        inline
                                        locale={i18n.language.toLowerCase() === 'en' ? undefined : i18n.language.toLowerCase()}
                                    />
                                    <div>{selectedItem?.value?.join(', ')}</div>
                                    {errorDates && (<p className='p-error'>{t('validateDates')}</p>)}
                                </>                                
                            )}

                            <div className='buttons-edit-form d-flex'>
                                <Button
                                    variant='outline'
                                    disabled={loading}
                                    onClick={() => {
                                        hide();
                                    }
                                    }>
                                    {t('back')}
                                </Button>
                                <Button type='submit' disabled={loading}>
                                    {loading ? <Spinner style={{ width: 20, height: 20 }} /> : t('save')}
                                </Button>
                            </div>
                        </Form>
                    }
                </Modal.Body>
            </Modal>
            <UniModal
                icon={faCircleCheck}
                title={t('successSave')}
                message=''
                show={showModalSuccess}
                onHide={() => {
                    setShowModalSuccess(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p></p>
                    <Button onClick={() => setShowModalSuccess(false)}>Ok!</Button>
                </div>
            </UniModal>
            <UniModal
                icon={faXmarkCircle}
                title={t('errorSave')}
                message=''
                iconColor='#EA2027'
                show={showModalError}
                onHide={() => {
                    setShowModalError(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p>{errorMessage}</p>
                    <Button onClick={() => setShowModalError(false)}>Ok</Button>
                </div>
            </UniModal>
        </>
    );
}

export default UniModalHolidayConfiguration;